module.exports = __webpack_public_path__ + "static/img/personalLittle.938e9ce5.svg";